<template>
  <div class="CTANext">

    <transition>
      <router-link :to="{ name: 'team.' + lang, params: $route.params }" v-if="tl.rythme.name == 'FINAL_STOP'" class="CTANext__credits Btn">
        {{ trans('credits') }}
      </router-link>
    </transition>

    <button class="CTANext__ghost" v-if="tl.status !== null" @focus="onWheel({ deltaY: !showPrevScreen ? -1 : 1 })" />

    <transition name="CTANext__screen" @leave="CTANextLeave">
      <div
        class="CTANext__screen"
        :style="{ boxShadow: getInnerShadow() }"
        v-if="(tl.status == 'pause' && showPrevScreen == false) || tl.status === null || stopped == true">
        <div class="CTANext__screen-gradient" :style="{ backgroundImage: getGradient() }" />
        <transition name="CTANext__screen-circle">
          <div class="CTANext__screen-circle" v-if="y === 0" />
        </transition>
        <transition @enter="circleFollowEnter" @leave="circleFollowLeave">
          <div ref="circle_follow" class="CTANext__screen-circle-follow" v-if="y > 0" />
        </transition>

        <button ref="trap" class="CTANext__trap"/>

        <button @click="onWheel({ deltaY: threshold })" class="CTANext__screen-text">
          {{ trans(ctaText) }}
        </button>

      </div>
    </transition>

    <transition name="CTANext__prevscreen">
      <div
        class="CTANext__prevscreen"
        v-if="showPrevScreen && tl.status !== null"
        @click="showPrevScreen = false"
        :style="{ backgroundImage: getGradient() }"
      >
        <button @click="play(0)">
          <svg viewBox="0 0 49.6 25.1" style="enable-background:new 0 0 49.6 25.1;" xml:space="preserve">
            <path class="st0" d="M38.6,22.1h-8v-1h8c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10H11C5.5,1,1,5.5,1,11c0,5.5,4.5,10,10,10h8v1h-8c-6.1,0-11-4.9-11-11S4.9,0,11,0h27.6c6.1,0,11,4.9,11,11C49.6,17.1,44.7,22.1,38.6,22.1z"/>
            <path class="st0" d="M22.6,21.3l-5.5-3.2c-0.2-0.1-0.5,0-0.5,0.3v6.4c0,0.2,0.3,0.4,0.5,0.3l5.5-3.2C22.9,21.7,22.9,21.4,22.6,21.3z"/>
          </svg>

          {{ trans('restart') }}

          <!--  
          <div v-if="!usingTab">{{ trans('restart') }}</div>
          <div v-if="usingTab">{{ trans('restart_chapter') }}</div> 
          -->

        </button>
        <button @click="play(before)" v-if="before">
          <svg viewBox="0 0 28.5 28.5">
            <path class="st0" d="M8.3,14.9l4.7,2.7c0.5,0.3,1.1-0.1,1.1-0.7v-5.4c0-0.6-0.6-1-1.1-0.7l-4.7,2.7C7.8,13.9,7.8,14.6,8.3,14.9z"/>
            <path class="st0" d="M13.9,14.9l4.7,2.7c0.5,0.3,1.1-0.1,1.1-0.7v-5.4c0-0.6-0.6-1-1.1-0.7l-4.7,2.7C13.4,13.9,13.4,14.6,13.9,14.9z"/>
            <path class="st0" d="M14.3,28.5C6.4,28.5,0,22.1,0,14.3C0,6.4,6.4,0,14.3,0c7.9,0,14.3,6.4,14.3,14.3C28.5,22.1,22.1,28.5,14.3,28.5z M14.3,1C7,1,1,7,1,14.3s6,13.3,13.3,13.3s13.3-6,13.3-13.3S21.6,1,14.3,1z"/>
          </svg>

          {{ trans('back') }}
          
          <!--  
          <div v-if="!usingTab">{{ trans('back') }}</div>
          <div v-if="usingTab">{{ trans('back_chapter') }}</div>
          -->

        </button>
        <!--div v-for="m in menu" :key="m.time" @click="play(m.time)">
          {{ m.name }}
        </div-->
      </div>
    </transition>

    <div v-if="$root.mode.dev" class="CTANext__infos">
      {{ parseInt(tl.time) }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'CTANext',
  props: ['tl'],
  translations: {
    fr: {
      restart: 'Recommencer le chapitre',
      restart_chapter: 'Appuyez sur la touche ENTRÉE pour recommencer le chapitre',
      back: "Reculer d'une étape",
      back_chapter: "Appuyez sur la touche ENTRÉE pour reculer d'une étape",
      credits: 'CRÉDITS',
      scroll: {
        start: 'FAITES DÉFILER POUR COMMENCER',
        continue: 'FAITES DÉFILER',
        restart: 'FAITES DÉFILER POUR RECOMMENCER',
      },
      tab: {
        start: 'Appuyez sur la touche ENTRÉE pour commencer',
        continue: 'Appuyez sur la touche ENTRÉE',
        restart: 'Appuyez sur la touche ENTRÉE pour recommencer'
      }
    },
    en: {
      restart: 'Restart chapter',
      restart_chapter: 'Press ENTER to restart chapter',
      back: 'back one step',
      back_chapter: 'Press ENTER to back one step',
      credits: 'CREDITS',
      scroll: {
        start: 'SCROLL TO START',
        continue: 'SCROLL TO CONTINUE',
        restart: 'SCROLL TO RESTART'
      },
      tab: {
        start: 'Press ENTER to start',
        continue: 'Press ENTER to continue',
        restart: 'Press ENTER to restart'
      }
    },
  },
  computed: {
    ctaText() {
      if(this.tl.status === null && this.$root.usingMouse) return 'scroll.start'
      else if(this.tl.status === null && this.$root.usingTab) return 'tab.start'
      if(this.tl.rythme.name == 'FINAL_STOP' && this.$root.usingMouse) return 'scroll.restart'
      else if(this.tl.rythme.name == 'FINAL_STOP' && this.$root.usingTab) return 'tab.restart' 
      if(this.$root.usingMouse) return 'scroll.continue'
      else if(this.$root.usingTab) return 'tab.continue'
    },
    usingTab() {
      if(this.$root.usingMouse) return false
      else return true
    }
  },
  data: () => ({
    chapter: null,
    stopped: false,
    showPrevScreen: false,
    y: 0,
    threshold: 0,
    touch: {
      start: { x: 0, y: 0 },
      end: { x: 0, y: 0 }
    },
    menu: [],
    before: null,
    compte: 0,
    current_key: null
  }),
  watch: {
    'tl.status' () {
      if(this.$root.speedMode && this.tl.status == 'pause')
        this.play()
    },
    y() {
      if(this.$refs.circle_follow && this.y > 0)
        TweenMax.to(this.$refs.circle_follow, .5, { y: -this.y / (this.threshold / 100) })
    },
    // 'touch.end.x'() {
    //   if(this.touch.start.x < this.touch.end.x)
    //     console.log('swiper right')
    //   if(this.touch.start.x > this.touch.end.x)
    //     console.log('swiper left')
    // },

    'touch.end.y'(newValue, oldValue) {
      // if(this.touch.start.y < this.touch.end.y)
      //   this.onWheel({ deltaY: -1 })

      const diff = this.touch.start.y - this.touch.end.y
      if(diff != 0)
        this.onWheel({ deltaY: diff }, 'touch')
    }
  },
  beforeDestroy() {
    document.removeEventListener('keypress', this.onKeyPress)
    document.removeEventListener('wheel', this.onWheel)
    document.removeEventListener('touchstart', this.onTouchStart)
    document.removeEventListener('touchmove', this.onTouchMove)
    document.removeEventListener('touchend', this.onTouchEnd)
    document.removeEventListener('keydown', this.onKeyDown)   

    if(this.chapter.$video)
      this.chapter.$video.removeEventListener('playing', this.onVideoDelay)
  },
  created() {
    if(this.$root.below('tablet'))
      this.threshold = 200

    this.threshold = 0
    // console.log(this.threshold);

    document.addEventListener('keypress', this.onKeyPress)
    document.addEventListener('wheel', this.onWheel)
    document.addEventListener('touchstart', this.onTouchStart)
    document.addEventListener('touchmove', this.onTouchMove)
    document.addEventListener('touchend', this.onTouchEnd)
    document.addEventListener('keydown', this.onKeyDown)

    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
    this.menu = this.chapter.$tl.getLabelsArray()

    if(this.chapter.$video)
      this.chapter.$video.addEventListener('playing', this.onVideoDelay)

    if(this.$root.speedMode && this.chapter.key != 'introduction')
      this.$parent.$refs.chapter_intro.start().then(() => this.play())
  },
  mounted() {
    TweenMax.from(this.$el, 1, { alpha: 0, delay: 1.5, onComplete: ()=>{
      this.$refs.trap.focus()
    }})
  },
  methods: {

    getContext() {
      return this.tl.status
    },
    forceStoppped() {
      this.stopped = true
    },
    onVideoDelay(event) {
      if(this.compte == 0)
        TweenMax.delayedCall(0, ()=>{
          this.chapter.$tl.play()
          this.compte += 1
          this.chapter.$video.removeEventListener('playing', this.onVideoDelay)
        })
    },
    circleFollowEnter(el, done) {
      TweenMax.from(el, 1, { scale: 0, alpha: 0, onComplete: done })
    },
    circleFollowLeave(el, done) {
      TweenMax.to(el, 1, { scale: 0, alpha: 0, onComplete: done })
    },
    CTANextLeave(el, done) {
      if(this.$refs.circle_follow)
        TweenMax.to(this.$refs.circle_follow, .7, { scale: 5, alpha: 0, onComplete: () => {
          if(this.$refs.circle_follow)
            TweenMax.set(this.$refs.circle_follow, { scale: 1, alpha: 1, y: 0 })
        }})

      setTimeout(() => done(), 800)
    },
    getInnerShadow() {
      const size = this.$root.below('phone') ? 50 : 500
      const top = (this.chapter.key == 'peace_tower') ? 50 : 0
      return `inset 0 ${top}px ${size}px ${this.chapter.colors.primary}`
    },
    getGradient() {
      const startColor = this.hexToRGB(this.chapter.colors.primary, 0)
      return `linear-gradient(to bottom, ${startColor}, ${this.chapter.colors.primary})`
    },
    onTouchMove(event) {
      this.touch.end.x = event.changedTouches[0].screenX
      this.touch.end.y = event.changedTouches[0].screenY
    },
    onTouchStart(event) {

      // console.log('event' + event);
      // console.log('event.changedTouches' + event.changedTouches[0]);
      // console.log('event.changedTouches[0].screenY' + event.changedTouches[0].screenY);

      this.touch.start.x = event.changedTouches[0].screenX
      this.touch.start.y = event.changedTouches[0].screenY
    },
    onTouchEnd(event) {
      this.touch.end.x = event.changedTouches[0].screenX
      this.touch.end.y = event.changedTouches[0].screenY
    },
    onWheel(e, type) {

      // console.log('xxxxxx');
      // console.log('onWheel '+ this.current_key + this.tl.status);
      // console.log('xxxxxx');

      if(event.srcElement.className == 'Navigation__burger-wrapper'
      || this.current_key == 9 && this.tl.status == 'play' && this.stopped == false)
        return

      type == 'touch'
      ? this.y = e.deltaY
      : this.y += e.deltaY

      // console.log('type '+ type);

      if(this.$reset) this.$reset.kill()
      this.$reset = TweenMax.delayedCall(1, () => {
        this.y = 0
        if(this.$refs.circle_follow)
          TweenMax.set(this.$refs.circle_follow, { y: 0, scale: 1, alpha: 1 })
      })

      const direction = e.deltaY  > 0 ? 'next' : 'prev'

      if(this.stopped == true) {
        this.$parent.$refs.timeline.unStopped()
        this.stopped = false
        this.play()
        return 
      }

      if(this.showPrevScreen && direction == 'next') return this.showPrevScreen = false
      if(this.showPrevScreen) return
      if(this.$route.meta.name != 'chapters') return
      if(this.y < this.threshold && direction == 'next') return

      if(direction == 'next' && this.tl.status == null
      || this.usingTab && e.deltaY == 0 && type == undefined) {
        this.tl.status = 'intro'
        this.$parent.$refs.chapter_intro.start().then(() => this.play())
      }

      else if(direction == 'next' && this.tl.status == 'pause'
      || this.usingTab && e.deltaY == 0 && type == undefined) {
        this.play()
      }

      else if(direction == 'prev') {
        this.showPrevScreen = true
        const currentLabel = this.chapter.$tl.getLabelBefore()
        const currentLabelTime = this.chapter.$tl.getLabelTime(currentLabel)
        if(this.chapter.$tl.getLabelBefore(currentLabelTime) != this.chapter.$tl.getLabelBefore(1))
          this.before = this.chapter.$tl.getLabelBefore(currentLabelTime)
      }
    },

    play(time) {

      if(this.$root.isModeVideo) {
        if(this.chapter.key == 'introduction'){
          this.chapter.$tl.play(time)
          return
        }
        if(time != undefined)
          this.chapter.$video.currentTime = this.getTime(time)
        this.chapter.$video.play()
      }
      if(!this.$root.isModeVideo
      || this.$root.isModeVideo && this.compte > 0) {
        this.chapter.$tl.play(time)
        this.compte += 1
      }
    },

    getTime(time) {
      if(time == 0) return time
      else return this.chapter.$tl._labels[time]
    },

    onKeyDown(event) {
      this.current_key = event.keyCode
    },

    onKeyPress(event) {

      if(event.keyCode == 32 && event.srcElement.className == 'Navigation__burger-wrapper')
        return

      const timeline = this.chapter.$tl
      switch(event.keyCode) {
        case 32:
          if(process.env.NODE_ENV !== 'production') {
            if(timeline.isActive()) timeline.pause()
            else this.play()

          } else {

            if(this.tl.status == null)
              this.$parent.$refs.chapter_intro.start().then(() => this.play())
            if(this.tl.status == 'pause')
              this.play()
          }
          break
        case 39:
        case 43:
        case 61:
        case 112:
        case 119:
          if(timeline.isActive()) timeline.pause()
          if(timeline.time() < timeline.duration()-1)timeline.seek(timeline.time()+1)
          this.tl.time = timeline.time()
          break
        case 37:
        case 45:
        case 111:
        case 113:
          if(timeline.isActive()) timeline.pause()
          if(timeline.time()>1) timeline.seek(timeline.time()-1)
           this.tl.time = timeline.time()
          break
        case 49:
          if(timeline.isActive()) timeline.pause()
          if(timeline.time() < timeline.duration()-1)timeline.seek(timeline.time()+.1)
          this.tl.time = timeline.time()
          break
      }
    },


  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.CTANext
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  z-index 9
  pointer-events none

  &__trap
    position absolute
    top 0
    left 0
    width 0px 
    height 0px 

  &__ghost
    position absolute

  &__credits
    position absolute
    color white
    top 17px
    right 70px
    z-index 99
    pointer-events all
    font-size 12px
    font-weight 900
    letter-spacing .2em
    border 1px solid white
    padding 10px 10px 8px
    text-decoration none
    text-transform uppercase
    display inline-block
    width auto

  &__screen
  &__prevscreen
    position absolute
    left 0px
    right 0px
    height 100%
    display flex
    justify-content center
    align-items center
    flex-direction column
    font-size 12px
    letter-spacing .2em
    +below(phone)
      font-size 12px

  &__screen
    transition opacity 2s
    &-enter
    &-leave-active
      opacity 0
    &-text
      position absolute
      bottom 50px
      font-weight 900
      color white
    &-circle
      width 10px
      height 10px
      position absolute
      bottom 200px
      border-radius 10px
      background white
      transition opacity 1s
      animation CTANext__screen-circle 2s ease-out infinite
      &-enter
      &-leave-active
        opacity 0
      +below(phone)
        bottom 130px
        animation CTANext__screen-circle-mobile 2s ease-out infinite
      @keyframes CTANext__screen-circle-mobile {
        from { transform: translateY(50px) }
        to {
          transform: translateY(0px)
          opacity: 0
        }
      }
      @keyframes CTANext__screen-circle {
        from { transform: translateY(100px) }
        to {
          transform: translateY(0px)
          opacity: 0
        }
      }

    &-circle-follow
      width 10px
      height 10px
      position absolute
      bottom 100px
      border-radius 10px
      background white
      +below(phone)
        bottom 80px
    &-gradient
      position absolute
      bottom -40px
      height 160px
      left 0
      right 0

  &__prevscreen
    color white
    transition transform 1s
    display flex
    flex-direction row
    text-transform uppercase
    align-items flex-end
    font-weight 900
    height 50%
    bottom 0
    &-enter
    &-leave-active
      transform translateY(100%)
    button
      cursor pointer
      pointer-events all
      margin 0 20px 100px
      text-align center
      color white
      svg
        fill white
        height 30px
        display block
        margin 0 auto 20px

  &__infos
    position absolute
    background black
    padding 5px
    right 0
    bottom 0px

</style>
